import type { ScenarioRow } from '../../executiveintel/framework';

type Props = { scenarios?: ScenarioRow[] };

export function ScenarioSimulationPanel({ scenarios = [] }: Props) {
  return (
    <div className="space-y-2">
      {scenarios.map((s) => (
        <div key={s.title} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <span className="rounded bg-brand-100 px-1.5 py-0.5 text-xs font-medium text-brand-700 dark:bg-brand-950 dark:text-brand-300">
            {s.type}
          </span>
          <p className="mt-1 text-sm font-medium">{s.title}</p>
          <div className="mt-1 flex items-center justify-between text-xs">
            <span className="text-success-600">{s.impact}</span>
            <span className="text-slate-500">{s.confidence}% confidence</span>
          </div>
        </div>
      ))}
    </div>
  );
}
